import { AppThunk } from '../../../store/rootReducer';
import { Wave } from '../types/wave.type';
import * as waveActions from '../actions/wave.actions';
import { updateUserDelineation } from '../../delineation/thunks/update-user-delineation.thunk';
import { userDelineationSelector } from '../../delineation/selectors/delineation.selectors';
import { selectDelineation } from '../../delineation/thunks/select-delineation.thunk';

export const addFirstWave =
  (wave: Wave): AppThunk =>
  (dispatch, getState) => {
    dispatch(waveActions.add({ wave }));
    dispatch(updateUserDelineation([wave]));
    const userDelineation = userDelineationSelector(getState());

    if (userDelineation == null) {
      return;
    }

    dispatch(selectDelineation(userDelineation.id));
  };
